import styled, { css } from 'styled-components';
import { em, rgba } from 'polished';
import { colors, isDefaultThemeMode } from 'core/theme';
import { ThumbnailBase } from '../Thumbnail/styled';
import { padding } from '../../constants';


const height = ({compact}) => (
  compact ? 190 : 290
);

export const StyledThumbnail = ThumbnailBase.extend`
  ${props => isDefaultThemeMode(props) && css`
    background-color: ${colors.HIGHLIGHT};
  `};
  height: ${height}px;
  position: relative;
`;


const fontSize = ({compact}) => em(
  compact ? 16 : 18
);

export const Duration = styled.div`
  background-color: ${colors.B26A};
  font-size: ${fontSize};
  padding: ${em(4)} ${em(16)};

  &:empty {
    display: none;
  }

  ${props => !isDefaultThemeMode(props) && css`
    background-color: ${colors.background};
    color: ${colors.text};
  `};
`;


export const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  color: ${colors.W};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${padding}px;

  & > button {
    transform: translateX(-0.5em);

    ${props => isDefaultThemeMode(props) ? css`
      color: ${colors.W};

      &:hover {
        color: ${rgba(colors.W, 0.88)};
      }

      &:active {
        background-color: ${rgba(colors.W, 0.12)};
        color: ${rgba(colors.W, 0.88)};
      }
    ` : css`
      background-color: ${colors.background};
      i {
        color: ${colors.text};
      }

      &:hover {
        background-color: ${colors.text};
        i {
          color: ${colors.background};
        }
      }
    `};

    & svg {
      width: 2em;
      height: 2em;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/elements/Card/components/ThumbnailVideo/styled.js